import { useState } from "react";
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField, Stack, FormHelperText } from "@mui/material";
import { isSameDay } from "date-fns";

interface CustomProps {
  formFields: any;
  setFormFields: any
}

const DateTimePicker = ({ formFields, setFormFields }: CustomProps) => {
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | null>(
    formFields?.date?.value || new Date()
  );
  const [selectedTime, setSelectedTime] = useState<Date | null>(
    formFields?.time?.value || new Date()
  );

  const handleDateChange = (newValue: Date | null) => {
    setSelectedDate(newValue);
    setFormFields((prevState: any) => ({
      ...prevState,
      date: { value: newValue, error: "" },
    }));
  };

  const handleTimeChange = (newValue: Date | null) => {
    if (newValue) {
      setSelectedTime(newValue);
      setFormFields((prevState: any) => ({
        ...prevState,
        time: { value: newValue, error: "" },
      }));
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack direction="row" spacing={2}>
        {/* Date Picker */}
        <Stack>
          <DatePicker
            value={selectedDate}
            onChange={handleDateChange}
            minDate={new Date()}
            disablePast
            slots={{ textField: TextField }}
            slotProps={{
              textField: {
                sx: { width: "fit-content", border: 0, borderRadius: "4px" },
                variant: "outlined",
                fullWidth: true,
                placeholder: "Select the date",
              },
            }}
          />
          {formFields.date.error && <FormHelperText error>{formFields.date.error}</FormHelperText>}
        </Stack>

        {/* Time Picker */}
        <Stack>
          <TimePicker
            value={selectedTime}
            onChange={handleTimeChange}
            slots={{ textField: TextField }}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            minTime={selectedDate && isSameDay(selectedDate, new Date()) ? new Date() : undefined}
            slotProps={{
              textField: {
                sx: { width: "fit-content", border: 0, borderRadius: "4px" },
                variant: "outlined",
                fullWidth: true,
                placeholder: "Select the time",
                onClick: () => setOpen(true),
              },
            }}
            ampm
          />
          {formFields.time.error && <FormHelperText error>{formFields.time.error}</FormHelperText>}
        </Stack>
      </Stack>
    </LocalizationProvider>
  );
};

export default DateTimePicker;
